import { useEffect, useRef, useState } from "react";
import { IconAdjustmentsHorizontal, IconEye, IconPlus } from "@tabler/icons-react";
import { Button } from "@onengine/component-library";
import {
  Drawer,
  DrawerBody,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/core/Drawer";
import { useFormStore } from "@/store/form-builder";
import { BUILDER_LABELS } from "../../data/builderLabels";
import { LeftPanel } from "../LeftPanel/LeftPanel";
import { FormEditor } from "../FormEditor/FormEditor";
import { RightPanel } from "../RightPanel/RightPanel";
import styles from "./NarrowEditorLayout.module.scss";

export function NarrowEditorLayout() {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const [propertiesOpen, setPropertiesOpen] = useState(false);
  const selectedQuestionId = useFormStore((s) => s.selectedQuestionId);
  const hasSelection = !!selectedQuestionId;
  const setIsPreview = useFormStore((s) => s.setIsPreview);
  const setPreviewPageIndex = useFormStore((s) => s.setPreviewPageIndex);
  const openPreview = () => {
    setPreviewPageIndex(0);
    setIsPreview(true);
  };

  const lastSelected = useRef(selectedQuestionId);
  useEffect(() => {
    if (paletteOpen && selectedQuestionId && selectedQuestionId !== lastSelected.current) {
      setPaletteOpen(false);
    }
    lastSelected.current = selectedQuestionId;
  }, [selectedQuestionId, paletteOpen]);

  return (
    <div className={styles.root}>
      <div className={styles.actionBar} role="toolbar" aria-label="Editor panels">
        <Button
          variant="secondary"
          size="small"
          iconLeft={<IconPlus size={14} />}
          onClick={() => setPaletteOpen(true)}
          htmlAttributes={{ "aria-haspopup": "dialog" }}
        >
          Add field
        </Button>
        <Button
          variant="secondary"
          size="small"
          iconLeft={<IconAdjustmentsHorizontal size={14} />}
          onClick={() => hasSelection && setPropertiesOpen(true)}
          htmlAttributes={{
            "aria-haspopup": "dialog",
            "aria-disabled": !hasSelection,
            title: hasSelection ? undefined : BUILDER_LABELS.propertiesNeedsField,
          }}
          className={hasSelection ? undefined : styles.disabledAction}
        >
          Properties
        </Button>
        <Button
          variant="secondary"
          size="small"
          iconLeft={<IconEye size={14} />}
          onClick={openPreview}
        >
          Preview
        </Button>
      </div>
      <div className={styles.canvas}>
        <FormEditor />
      </div>
      <Drawer open={paletteOpen} onOpenChange={setPaletteOpen}>
        <DrawerContent className={styles.drawer}>
          <DrawerHeader>
            <DrawerTitle>Fields and pages</DrawerTitle>
            <DrawerClose />
          </DrawerHeader>
          <DrawerBody noPadding>
            <div className={styles.panel}>
              <LeftPanel />
            </div>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <Drawer open={propertiesOpen} onOpenChange={setPropertiesOpen}>
        <DrawerContent className={styles.drawer}>
          <DrawerHeader>
            <DrawerTitle>Properties</DrawerTitle>
            <DrawerClose />
          </DrawerHeader>
          <DrawerBody noPadding>
            <div className={styles.panel}>
              <RightPanel />
            </div>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </div>
  );
}
